module.exports = "<div [hidden]=\"!!control ? !(!control.valid && (control.touched || submitted)) : true\">\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/validation/field.error.html
// module id = 936
// module chunks = 0